// src/components/mantenciones/TriState.jsx
import React from 'react';
import { theme } from 'antd';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { MAINT_STATE_COLOR } from './maintenanceColors';

const { useToken } = theme;

const OPTS = [
  { k: 'EXITOSO', label: 'Exitoso', Icon: CheckCircleOutlined },
  { k: 'RECHAZADO', label: 'Con problema', Icon: WarningOutlined },
  { k: 'NA', label: 'No aplica', Icon: CloseCircleOutlined },
];

// Control 3-estados. Click sobre el activo lo deselecciona (onPick null),
// reproduciendo la interacción del diseño. `disabledKeys` deshabilita opciones
// (ej. "Exitoso"/"No aplica" cuando un hallazgo previo sigue presente); el
// estado activo nunca se deshabilita para poder togglearlo.
function TriState({ value, onPick, disabledKeys, disabledHint }) {
  const { token } = useToken();
  const disabled = new Set(disabledKeys || []);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 6, marginTop: 10 }}>
      {OPTS.map(({ k, label, Icon }) => {
        const on = value === k;
        const isDisabled = disabled.has(k) && !on;
        const color = MAINT_STATE_COLOR[k];
        return (
          <button
            key={k}
            type="button"
            disabled={isDisabled}
            title={isDisabled ? disabledHint : undefined}
            onClick={() => {
              if (isDisabled) return;
              onPick(on ? null : k);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              padding: '8px 4px',
              borderRadius: token.borderRadius,
              border: `1px solid ${on ? color : token.colorBorder}`,
              background: on ? color : token.colorBgContainer,
              color: on ? '#fff' : token.colorTextSecondary,
              fontWeight: 600,
              fontSize: 12,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.45 : 1,
              transition: `all ${token.motionDurationMid}`,
            }}
          >
            <Icon />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default TriState;
